import ptBR from '../locales/pt-BR.json';
import enUS from '../locales/en-US.json';
import esES from '../locales/es-ES.json';

export const messages = {
  'pt-BR': ptBR,
  'en-US': enUS,
  'es-ES': esES,
};

export const defaultLocale = 'en-US';

export const getMessages = (locale: any) => {
  // @ts-ignore
  return messages[locale] || messages[defaultLocale];
};

export const getSupportedLocales = () => {
  return Object.keys(messages);
};
